import landmark from "@/api/landmarks";

export default {
  state: {
    landmarks: [],
    landmarkMarkers: []
  },

  mutations: {
    ["RETRIEVE_LANDMARKS"](state, data) {
      state.landmarks = data;
    },
    ["SET_LANDMARK_MARKERS"](state, data) {
      state.landmarkMarkers = data;
    }
  },

  actions: {
    async retrieveLandmarks(context) {
      try {
        const params = {
          account_id: await context.dispatch("showAccountID")
        };
        const res = await landmark.index(params);
        const landmarkList = res.data.data.list;
        context.commit("RETRIEVE_LANDMARKS", landmarkList);
        return landmarkList;
      } catch (error) {
        console.log(error);
      }
    },
    async insertLandmark(context, paramObj) {
      try {
        const params = {
          account_id: await context.dispatch("showAccountID")
        };
        Object.assign(params, paramObj);
        await landmark.insert(params);
      } catch (error) {
        console.log(error);
      }
    },
    async updateLandmark(context, paramObj) {
      try {
        const params = {
          account_id: await context.dispatch("showAccountID")
        };
        Object.assign(params, paramObj);
        await landmark.update(params);
      } catch (error) {
        console.log(error);
      }
    },
    async deleteLandmark(context, paramObj) {
      try {
        const params = {
          account_id: await context.dispatch("showAccountID")
        };
        Object.assign(params, paramObj);
        await landmark.del(params);
      } catch (error) {
        console.log(error);
      }
    },
    setLandmarkMarkers(context, markers) {
      context.commit("SET_LANDMARK_MARKERS", markers);
    }
  },

  getters: {
    getLandmarks(state) {
      return state.landmarks;
    },
    getLandmarkMarkers(state) {
      return state.landmarkMarkers;
    }
  }
};
